<ion-menu contentId="main-content" menuId="app-menu" side="end" (ionDidClose)="handleIonDidClose($event)" (ionWillOpen)="handleIonWillOpen()">
  <ion-nav #modalNav [root]="root" />
</ion-menu>
